
import Vue, {PropType} from 'vue'
import {Multimedia} from '@/model/Multimedia'
import Youtube from '@/service/Youtube'

export default Vue.extend({
  name: 'ImageGallery',
  props: {
    multimedia: {
      type: Array,
    },
    mainImage: {
      type: Object as PropType<Multimedia>,
    },
  },
  computed: {
    leftWidth: function () {
      return this.responsiveConfiguration[this.$vuetify.breakpoint.name]
        .leftWidthPercent
    },
    rightWidth: function () {
      return this.responsiveConfiguration[this.$vuetify.breakpoint.name]
        .rightWidthPercent
    },
    marginLeft: function () {
      return this.responsiveConfiguration[this.$vuetify.breakpoint.name]
        .marginLeft
    },
    height: function () {
      return this.responsiveConfiguration[this.$vuetify.breakpoint.name].height
    },
    sortedImages: function (): Multimedia[] {
      return this.multimedia as Multimedia[]
    },
  },
  mounted() {
    if (this.multimedia) {
      this.setCurrentImage(this.sortedImages[0] as Multimedia, 0)
    }
  },
  data: () => ({
    currentImage: null as Multimedia | null,
    youtubeService: Youtube,
    currentImageIndex: 0,
    responsiveConfiguration: {
      xs: {
        leftWidthPercent: 80,
        rightWidthPercent: 20,
        marginLeft: 0,
        height: 250,
      },
      sm: {
        leftWidthPercent: 85,
        rightWidthPercent: 15,
        marginLeft: 12,
        height: 400,
      },
      md: {
        leftWidthPercent: 90,
        rightWidthPercent: 10,
        marginLeft: 12,
        height: 450,
      },
      lg: {
        leftWidthPercent: 90,
        rightWidthPercent: 10,
        marginLeft: 12,
        height: 450,
      },
      xl: {
        leftWidthPercent: 90,
        rightWidthPercent: 10,
        marginLeft: 12,
        height: 550,
      },
    },
  }),
  methods: {
    scrollImages: function () {
      const mediaList = this.$refs.mediaList as HTMLElement
      if (!mediaList) {
        return
      }
      const mediaListHeight = mediaList.clientHeight
      if (!mediaList.firstElementChild) {
        return
      }
      const imgHeight =
        (mediaList.firstElementChild as HTMLElement).offsetHeight + 15
      const currentScroll = mediaList.scrollTop
      const imageTop = this.currentImageIndex * imgHeight
      const imageBottom = (this.currentImageIndex + 1) * imgHeight

      if (imageTop < currentScroll) {
        mediaList.scroll(0, imageTop - 20)
      } else if (imageBottom > currentScroll + mediaListHeight) {
        mediaList.scroll(0, imageBottom - mediaListHeight)
      }
    },
    setCurrentImage: function (multimedia: Multimedia, index: number) {
      this.currentImage = multimedia
      this.currentImageIndex = index
      this.scrollImages()
    },
    nextImage: function () {
      if (this.currentImageIndex === this.sortedImages.length - 1) {
        return
      }

      this.currentImage = this.sortedImages[
        ++this.currentImageIndex
        ] as Multimedia

      this.scrollImages()
    },
    prevImage: function () {
      if (this.currentImageIndex === 0) {
        return
      }

      this.currentImage = this.sortedImages[
        --this.currentImageIndex
        ] as Multimedia

      this.scrollImages()
    },
  },
  watch: {
    mainImage: function () {
      this.setCurrentImage(this.sortedImages[0] as Multimedia, 0)
    },
    multimedia: function () {
      this.setCurrentImage(this.sortedImages[0] as Multimedia, 0)
    },
  },
})
